import { faPlanetRinged } from "@fortawesome/pro-regular-svg-icons";
import { faPlanetMoon } from "@fortawesome/pro-regular-svg-icons/faPlanetMoon";
import type { OrderResourceSelectBoxOptions } from "@mittwald/flow-components/dist/components/OrderResourceSelect/components";
import type { SelectBoxOptions } from "@mittwald/flow-components/dist/components/SelectBox";
import { iconProject } from "@mittwald/flow-icons/dist/project";
import type { ProSpaceArticle } from "../../article";
import { ProSpaceResourceTag } from "../../article";
import type DedicatedServerArticle from "../../article/DedicatedServerArticle";
import type { WebhostingArticle } from "../../article/WebhostingArticle";
import ServerList from "../../server/ServerList";
import SpaceServerArticleUI from "./ServerArticleUI";

const proSpaceResourceTags: ProSpaceResourceTag[] = [
  ProSpaceResourceTag.balanced,
  ProSpaceResourceTag.ram,
  ProSpaceResourceTag.cpu,
];

export class ProjectArticleUI {
  public static readonly proSpaceLiteIcon = faPlanetMoon;
  public static readonly proSpaceIcon = faPlanetRinged;
  public static readonly webhostingIcon = iconProject;

  public static buildResourceSelectBoxOptions(
    currentArticle?: ProSpaceArticle | DedicatedServerArticle,
  ): SelectBoxOptions {
    return proSpaceResourceTags.map((tag) => ({
      value: tag,
      title: tag,
      marked: tag === currentArticle?.resourceTag,
    }));
  }

  public static useArticleTypeOptions(customerId?: string): SelectBoxOptions {
    const serversAvailable =
      !ServerList.useLoadByOptionalCustomerId(customerId).isEmpty;

    return [
      {
        value: "webhosting",
        title: "webhosting",
        icon: ProjectArticleUI.webhostingIcon,
        description: "webhostingDescription",
        additionalInfo: { i18n: "webhostingPrice" },
      },
      {
        value: "vServer",
        title: "vServer",
        icon: SpaceServerArticleUI.icon,
        description: "vServerDescription",
        additionalInfo: { i18n: "vServerInclusive" },
        disabled: !serversAvailable,
      },
    ];
  }

  public static buildProSpaceArticleSelectBoxOptions(
    articles: ProSpaceArticle[],
    currentArticle?: ProSpaceArticle,
  ): OrderResourceSelectBoxOptions {
    return articles
      .sort((l, r) => l.machineType.compare(r.machineType))
      .map((article) => ({
        value: article.id,
        title: { text: article.machineType.getDescription("cpu") },
        description: { text: article.machineType.getDescription("memory") },
        marked: currentArticle?.isEqual(article),
      }));
  }

  public static buildWebhostingArticleSelectBoxOptions(
    articles: WebhostingArticle[],
    currentArticle?: WebhostingArticle,
  ): OrderResourceSelectBoxOptions {
    return articles
      .sort((l, r) => l.machineType.compare(r.machineType))
      .map((article) => ({
        value: article.id,
        title: { text: article.machineType.getDescription("cpu") },
        description: { text: article.machineType.getDescription("memory") },
        marked: currentArticle?.isEqual(article),
      }));
  }
}

export default ProjectArticleUI;
